import { render, staticRenderFns } from "./PlosEx_Export.vue?vue&type=template&id=1fa40a78"
import script from "./PlosEx_Export.vue?vue&type=script&lang=js"
export * from "./PlosEx_Export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports